module.exports = __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu7mxKKTU1Kvnz.aa54ea59.woff2";